import { render, staticRenderFns } from "./upLink.vue?vue&type=template&id=1f00b26e&scoped=true&"
import script from "./upLink.vue?vue&type=script&lang=js&"
export * from "./upLink.vue?vue&type=script&lang=js&"
import style0 from "./upLink.vue?vue&type=style&index=0&id=1f00b26e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f00b26e",
  null
  
)

export default component.exports